import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXexceptionunauthorizedgridicon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.82513 1.05123C5.00855 0.350411 5.60026 1.58895e-08 6.25 0C6.89974 -1.58895e-08 7.49145 0.350411 8.67487 1.05123L9.07513 1.28827C10.2585 1.98909 10.8503 2.3395 11.1751 2.91667C11.5 3.49383 11.5 4.19466 11.5 5.5963V6.07037C11.5 7.47201 11.5 8.17283 11.1751 8.75C10.8503 9.32717 10.2585 9.67758 9.07513 10.3784L8.67487 10.6154C7.49145 11.3163 6.89974 11.6667 6.25 11.6667C5.60026 11.6667 5.00855 11.3163 3.82513 10.6154L3.42487 10.3784C2.24145 9.67758 1.64974 9.32717 1.32487 8.75C1 8.17283 1 7.47201 1 6.07037V5.5963C1 4.19466 1 3.49383 1.32487 2.91667C1.64974 2.3395 2.24145 1.98909 3.42487 1.28827L3.82513 1.05123ZM6.83333 8.16667C6.83333 8.48883 6.57217 8.75 6.25 8.75C5.92783 8.75 5.66667 8.48883 5.66667 8.16667C5.66667 7.8445 5.92783 7.58333 6.25 7.58333C6.57217 7.58333 6.83333 7.8445 6.83333 8.16667ZM6.25 2.47917C6.49162 2.47917 6.6875 2.67504 6.6875 2.91667V6.41667C6.6875 6.65829 6.49162 6.85417 6.25 6.85417C6.00838 6.85417 5.8125 6.65829 5.8125 6.41667V2.91667C5.8125 2.67504 6.00838 2.47917 6.25 2.47917Z",
		fill: "#EF3826"
	})
});
export default SvgXexceptionunauthorizedgridicon;
